import React from 'react';

const VCardQRForm = ({ vcardData, onDataChange }) => {
  const handleFieldChange = (field, value) => {
    onDataChange({
      ...vcardData,
      [field]: value
    });
  };

  return (
    <div className="vcard-form">
      <div className="form-group">
        <label htmlFor="vcard-name">Nome Completo</label>
        <input
          id="vcard-name"
          type="text"
          value={vcardData.name || ''}
          onChange={(e) => handleFieldChange('name', e.target.value)}
          placeholder="João Silva"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="vcard-org">Organização</label>
        <input
          id="vcard-org"
          type="text"
          value={vcardData.organization || ''}
          onChange={(e) => handleFieldChange('organization', e.target.value)}
          placeholder="CAPO Software"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="vcard-title">Cargo/Título</label>
        <input
          id="vcard-title"
          type="text"
          value={vcardData.title || ''}
          onChange={(e) => handleFieldChange('title', e.target.value)}
          placeholder="Desenvolvedor"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="vcard-phone">Telefone</label>
        <input
          id="vcard-phone"
          type="tel"
          value={vcardData.phone || ''}
          onChange={(e) => handleFieldChange('phone', e.target.value)}
          placeholder="+55 11 99999-9999"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="vcard-email">E-mail</label>
        <input
          id="vcard-email"
          type="email"
          value={vcardData.email || ''}
          onChange={(e) => handleFieldChange('email', e.target.value)}
          placeholder="contato@caposoftware.com"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="vcard-website">Website</label>
        <input
          id="vcard-website"
          type="url"
          value={vcardData.website || ''}
          onChange={(e) => handleFieldChange('website', e.target.value)}
          placeholder="https://caposoftware.com"
          className="text-input"
        />
      </div>

      <div className="form-group">
        <label htmlFor="vcard-address">Endereço</label>
        <textarea
          id="vcard-address"
          value={vcardData.address || ''}
          onChange={(e) => handleFieldChange('address', e.target.value)}
          placeholder="Rua das Flores, 123&#10;Centro - São Paulo - SP&#10;01234-567"
          className="text-area"
          rows="3"
        />
      </div>

      <div className="form-group">
        <label htmlFor="vcard-note">Observações</label>
        <textarea
          id="vcard-note"
          value={vcardData.note || ''}
          onChange={(e) => handleFieldChange('note', e.target.value)}
          placeholder="Informações adicionais..."
          className="text-area"
          rows="2"
        />
      </div>
    </div>
  );
};

export default VCardQRForm;
